export function convertToTolgeeLanguageCode(languageCode: string) {
  switch (languageCode) {
    case "en-US":
    case "en-GB":
      return "en";
    // Add more mappings as needed
    default:
      return languageCode;
  }
}

export function convertFromTolgeeLanguageCode(tolgeeCode: string) {
  switch (tolgeeCode) {
    case "en":
      return "en-US";
    // Add more mappings as needed
    default:
      return tolgeeCode;
  }
}
